import { styled } from '@mui/material/styles';
import { Alert } from '@mui/material';
import Button from 'mui/components/elements/DS_ButtonLink';
import {
  SharedContainerStepsStyles,
  SharedStyledResultsWrapper,
  SharedColumnSummary,
  SharedColumnImage,
} from '../../shared/styles/sharedBookingStyles';

export const StyledRescheduleWrapper = styled('div')(
  ({ theme }) => `
    ${SharedStyledResultsWrapper({ theme })}
`,
);

export const ColumnSummary = styled('article')(
  ({ theme }) => `
  ${SharedContainerStepsStyles({ theme })};
  ${SharedColumnSummary({ theme })};
`,
);

export const StyledImage = styled('div')(
  ({ theme }) => `
  ${SharedColumnImage({ theme })};
  margin-top: ${theme.spacing(['xs'])};
   ${theme.breakpoints.up('lg')} {
     margin-top: 0};
   }
`,
);

export const StyledRescheduledButton = styled(Button)(
  ({ selectedValue }) => `

  display: ${selectedValue ? `block` : `none`};

`,
);

export const StyledCancelledWrapper = styled('div')(
  ({ theme }) => `

    display: flex;
    gap: ${theme.spacing(['xs'])};
    justify-content: start;
    flex-wrap: wrap;
 
`,
);

export const StyledAlert = styled(Alert)(
  ({ theme }) => `
      margin-top: -${theme.DS_spacing(['xxs'])};
      margin-bottom: ${theme.DS_spacing(['xs'])};
      padding: ${theme.DS_spacing(['xxxs'])}  ${theme.DS_spacing(['xxs'])};
      border: 1px solid ${theme.DS_palette.buttons.error};
      background-color: transparent;
      color: ${theme.DS_palette.text.secondary};
      border-radius: ${theme.DS_border.radius.button};
      max-width: 60ch;
      .MuiAlert-icon {
         color: ${theme.DS_palette.buttons.error};
      }
     ${theme.breakpoints.up('lg')} {
       padding: ${theme.DS_spacing(['xxs'])};
     }

`,
);

export const StyledWrapperLoader = styled('div')(
  ({ theme }) => `
   
      width: 100%;
      background-color: rgba(0,0,0,0.3);
      position: fixed;
      height: 100%;
      z-index:1090;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      
      ${theme.breakpoints.up('lg')} {
         > div {
          font-size: 12px;
        } 
      }
 
   
`,
);

export const StyledInitialCancelledWrapper = styled('div')(
  ({ theme }) => `
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${theme.DS_spacing(['md'])};
  p {
    margin-right: ${theme.DS_spacing(['xxxs'])};
  }
  button {
    white-space: nowrap;
    color: ${theme.DS_palette.buttons.error};
    text-decoration: underline;
    &:hover {
      cursor: pointer;
      text-decoration: none;
    }
  }
`,
);
